import { create } from "zustand";

interface HookProps {
  open: boolean;
  leaveId: string;
  setLeaveId: (id: string) => void;
  onOpenChange: (open: boolean) => void;
}

export const useTakeActionModal = create<HookProps>()((set) => ({
  open: false,
  leaveId: "",
  setLeaveId: (id) =>
    set(() => ({
      leaveId: id,
    })),
  onOpenChange: (open) =>
    set(() => ({
      open,
    })),
}));
